import HeaderTemplate from './templates/header/header'
import FooterTemplate from './templates/footer/footer'
import RootRouter from './navigation/route'
import { useEffect } from "react"
import { useLocation } from 'react-router-dom';
import './App.css';
import CreateEvents from './Admin/CreateEvents';

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isAuthRoute = location.pathname.startsWith('/auth');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div className="App">
      {(!isAdminRoute && !isAuthRoute) && <HeaderTemplate />}
    
      <RootRouter/>
      
      <FooterTemplate />
    </div>
  );
}

export default App;
